import { render } from "./ProductBranchEdit.vue?vue&type=template&id=0c0df4dc&ts=true"
import script from "./ProductBranchEdit.vue?vue&type=script&lang=ts"
export * from "./ProductBranchEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/root/.jenkins/workspace/test-saas-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__